import { Box, Link, List, ListItem, ListItemText, Typography } from '@mui/material';
import { getContactEmail } from '../../utils/env';

const TermsOfServicePage = () => {
  const contactEmail = getContactEmail();

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Termos de Uso
      </Typography>
      <Typography color="text.secondary">
        Ao usar a {process.env.REACT_APP_SITE_NAME}, você concorda com estes termos. Se não
        concordar, não utilize o serviço.
      </Typography>

      <Box>
        <Typography variant="h6">Uso do serviço</Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Informe dados corretos e mantenha suas credenciais em segurança." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Use a plataforma para fins lícitos e pessoais de listas de presentes." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Podemos suspender contas em caso de abuso, fraude ou violação de políticas." />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="h6">Pagamentos e taxas</Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Pix é realizado direto para o dono da lista, conforme configurado." />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="h6">Produtos, preços e links de parceiros</Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Algumas páginas (como Ideias de Presentes) exibem produtos de lojas parceiras (ex.: Amazon, Magazine Luiza, Mercado Livre). Ao clicar, você é levado ao site da loja, onde a compra é concluída." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Podemos receber comissão de afiliado por compras feitas através desses links, sem custo adicional para você." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Preços, disponibilidade, fotos e descrições são atualizados periodicamente, mas podem mudar a qualquer momento e estar temporariamente desatualizados aqui. O valor e as condições válidos são sempre os exibidos no site do parceiro no momento da compra." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Não nos responsabilizamos por preços, estoque, entrega, garantia ou atendimento dos produtos de parceiros — essas responsabilidades são da loja vendedora. Confira sempre as informações na página do produto antes de comprar." />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="h6">Conteúdo</Typography>
        <Typography color="text.secondary">
          Você é responsável pelo conteúdo das suas listas e mensagens. Não publique material ilegal
          ou que viole direitos de terceiros.
        </Typography>
      </Box>

      <Box>
        <Typography variant="h6">Encerramento</Typography>
        <Typography color="text.secondary">
          Podemos suspender ou encerrar o acesso em caso de violação ou risco à segurança. Você pode
          parar de usar o serviço a qualquer momento.
        </Typography>
      </Box>

      <Box>
        <Typography variant="h6">Alterações</Typography>
        <Typography color="text.secondary">
          Podemos atualizar estes termos. O uso continuado após mudanças significa que você concorda
          com os termos atualizados.
        </Typography>
      </Box>

      <Box>
        <Typography variant="h6">Contato</Typography>
        <Typography color="text.secondary">
          Dúvidas? Fale com <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>.
        </Typography>
      </Box>
    </Box>
  );
};

export default TermsOfServicePage;
